import Typography from '@/components/shared/typography/typography.component';
import {
    ImperfectionReportItem,
    ImperfectionReportSection,
    ImperfectionStatusEnum,
} from '@/types';
import { FC, Fragment, useState } from 'react';
import UnFultyImprefectionItem from './unfultyImprefectionItem.component';
import ImprefectionReportImageGallery from '@/components/shared/Imprefections-images-gallery/ImprefectionsGallery.component';
import myImageLoader from '@/image.local.loader';

const ExteriorItemContent = ({
    item,
    tags,
}: {
    item: ImperfectionReportItem;
    tags: string | null;
}) => {
    const [disableGallery, setDisableGallery] = useState(true);
    const getDisableGalleryState = (disableGallery: boolean) => {
        setDisableGallery(disableGallery);
    };
    return (
        <div className={`${disableGallery ? 'disable-gallery' : ''}`}>
            <div className="disable-gallery:min-h-14 flex disable-gallery:flex-row disable-gallery:gap-0 flex-col md:flex-row md:gap-0 gap-3 w-full justify-start items-center relative">
                <div className="flex disable-gallery:order-[0] disable-gallery:self-center order-2 md:order-[0] self-start md:self-center">
                    {item.highlightedImages &&
                        item.highlightedImages.length > 0 && (
                            <div className="w-[66px] flex-shrink-0 flex content-center items-center">
                                <img
                                    className={''}
                                    src={myImageLoader({
                                        src: item.highlightedImages[0],
                                        quality: 100,
                                        fillColor: 'transparent',
                                    })}
                                    alt={item.name_en}
                                />
                            </div>
                        )}
                    <div className="flex flex-col gap-1 ">
                        <Typography
                            variant="body2SemiBold"
                            className="!text-gray-700 ar:hidden"
                        >
                            {item.name_en}
                        </Typography>
                        <Typography
                            variant="body2SemiBold"
                            className="!text-gray-700 en:hidden"
                        >
                            {item.name_ar}
                        </Typography>
                        {tags && (
                            <Typography
                                variant="caption"
                                className={`!text-gray-600 transition-[width] duration-500 ${
                                    item.images &&
                                    'md:disable-gallery:w-full disable-gallery:md:w-full]'
                                } w-full`}
                            >
                                {tags}
                            </Typography>
                        )}
                    </div>
                </div>
                {item.images && (
                    <div className={'ar:mr-auto en:ml-auto flex-none'}>
                        <ImprefectionReportImageGallery
                            getDisableGalleryState={getDisableGalleryState}
                            images={item.images}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

const ExteriorPartsContent: FC<{
    section: ImperfectionReportSection[];
    IS_RTL: boolean;
}> = ({ section, IS_RTL }) => {
    return (
        <div className="flex flex-col gap-5  pb-20 md:pb-2">
            {section?.map(section => {
                const hasSubtitle =
                    (section.subtitle_en && section.subtitle_en.length !== 0) ||
                    (section.subtitle_ar && section.subtitle_ar.length !== 0);
                return (
                    <div key={`${section.name_en} section-name`}>
                        <div className="flex items-center gap-2.5 mb-2">
                            {section.section_good_icon && (
                                <div className="w-6 h-6 self-start">
                                    <img
                                        src={section.section_good_icon}
                                        alt="unfaulty-icon"
                                        className="object-fill h-full w-full"
                                    />
                                </div>
                            )}
                            <div className="w-[calc(100%-40px)]">
                                <Typography
                                    variant="body2SemiBold"
                                    className="!text-gray-700 ar:hidden"
                                >
                                    {section.name_en}
                                </Typography>
                                <Typography
                                    variant="body2SemiBold"
                                    className="!text-gray-700 en:hidden"
                                >
                                    {section.name_ar}
                                </Typography>

                                {hasSubtitle && (
                                    <>
                                        <Typography
                                            variant="caption"
                                            className="!text-gray-600 ar:hidden"
                                        >
                                            {section.subtitle_en}
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            className="!text-gray-600 en:hidden"
                                        >
                                            {section.subtitle_ar}
                                        </Typography>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="w-full flex flex-col bg-white border border-gray-200 rounded-xl">
                            <div className="w-full py-4 px-3 flex items-start">
                                <div className="flex flex-col gap-1 w-full">
                                    <div className="flex flex-col gap-3">
                                        {section?.items?.map((item, index) => {
                                            const tags = item?.tags
                                                ?.map(item =>
                                                    IS_RTL
                                                        ? item.tag_ar
                                                        : item.tag_en
                                                )
                                                .join(' - ');
                                            if (
                                                item.status ===
                                                    ImperfectionStatusEnum.UnFaulty ||
                                                item.status ===
                                                    ImperfectionStatusEnum.Fixed
                                            ) {
                                                return (
                                                    <UnFultyImprefectionItem
                                                        item={item}
                                                        key={
                                                            item.imperfection_item_id
                                                        }
                                                        tags={tags}
                                                        IS_RTL={IS_RTL}
                                                    />
                                                );
                                            }
                                            return (
                                                <Fragment
                                                    key={
                                                        item.imperfection_item_id
                                                    }
                                                >
                                                    <ExteriorItemContent
                                                        item={item}
                                                        tags={tags}
                                                    />
                                                    {index <
                                                        section.items.length -
                                                            1 && (
                                                        <div className="w-full border-b border-gray-200 my-2"></div>
                                                    )}
                                                </Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ExteriorPartsContent;
